"use strict";
exports.__esModule = true;
var react_1 = require("react");
/**
 * Private module for internal usage
 */
function useId(idOverride) {
    var _a = react_1.useState(idOverride), defaultId = _a[0], setDefaultId = _a[1];
    var id = idOverride || defaultId;
    react_1.useEffect(function () {
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the random value for client-side rendering only.
            // We can't use it server-side.
            setDefaultId("mfcl-" + Math.round(Math.random() * 1e5));
        }
    }, [defaultId]);
    return id;
}
exports["default"] = useId;
